(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2503],{

/***/ 22824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports default, parseElementList */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25935);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



function reStructSEO(seo) {
  var fullHead = seo.fullHead.split("\n").join("");
  return _objectSpread(_objectSpread({}, seo), {}, {
    fullHead: fullHead
  });
}
function parseElementList(list) {
  return parse(list).map(function (item, index) {
    return /*#__PURE__*/createElement(item === null || item === void 0 ? void 0 : item.type, _objectSpread(_objectSpread({}, item === null || item === void 0 ? void 0 : item.props), {}, {
      key: index + 10
    }));
  });
}

/***/ }),

/***/ 23403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ FaFacebookF; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaFacebookF(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 320 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 19329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ FaLinkedinIn; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaLinkedinIn(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 448 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 62353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ FaTwitter; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaTwitter(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 68840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ FiCalendar; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FiCalendar(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "4",
        "width": "18",
        "height": "18",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "2",
        "x2": "16",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "2",
        "x2": "8",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "10",
        "x2": "21",
        "y2": "10"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 67611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./common/source-function/reStructSEO.js
var reStructSEO = __webpack_require__(22824);
// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/atoms/ButtonNew/index.js
var ButtonNew = __webpack_require__(30852);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaFacebookF.js
var FaFacebookF = __webpack_require__(23403);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaLinkedinIn.js
var FaLinkedinIn = __webpack_require__(19329);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaTwitter.js
var FaTwitter = __webpack_require__(62353);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/templates/common/Author/CardImageDes/Index.module.scss
var Index_module = __webpack_require__(39108);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/common/Author/CardImageDes/index.js









var FaIcons = {
  FaFacebookF: FaFacebookF/* FaFacebookF */.t,
  FaTwitter: FaTwitter/* FaTwitter */.f,
  FaLinkedinIn: FaLinkedinIn/* FaLinkedinIn */.B
};
function CardImageDes(_ref) {
  var Card = _ref.Card,
      total = _ref.total;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: " container ".concat((Index_module_default()).cardContainer),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "".concat((Index_module_default()).cardWrapper),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat((Index_module_default()).imgCard),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
            src: Card.image.src,
            alt: Card.image.altText
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "lg:ml-52 lg:pl-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            as: "h1",
            className: "mb-4 mt-6 text-bbc-30px font-semibold text-bbc-brand-800 lg:mt-0",
            children: Card.title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "bbc-gray text-base leading-[26px]",
            children: Card === null || Card === void 0 ? void 0 : Card.thedescription.map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "mb-4",
                dangerouslySetInnerHTML: {
                  __html: item
                }
              }, index);
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("em", {
              className: "mb-2 lg:float-left",
              children: ["A collection of ", total, " posts"]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "lg:float-right",
              children: Card === null || Card === void 0 ? void 0 : Card.socialNetwork.map(function (item, index) {
                var As = FaIcons[item.icon];
                return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  href: item.url,
                  rel: "noreferrer",
                  className: "mt-4 mr-2 inline-block h-8 w-8 rounded-full py-2 text-center text-white lg:mt-0 lg:mr-0 lg:ml-2",
                  target: "_blank",
                  style: {
                    backgroundColor: "".concat(item.color)
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(As, {
                    className: "mx-auto"
                  })
                }, index);
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "clear-both"
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "clear-both"
        })]
      })
    })
  });
}
// EXTERNAL MODULE: ./common/functions.js
var functions = __webpack_require__(98989);
// EXTERNAL MODULE: ./components/atoms/Icon/fi/FiCalendar.js
var FiCalendar = __webpack_require__(68840);
;// CONCATENATED MODULE: ./components/templates/common/Author/CardPostItemFull/index.js




/** ========== */




var CardPostItemFull = function CardPostItemFull(_ref) {
  var _post$categories, _post$featuredImage;

  var post = _ref.post;
  var category = post === null || post === void 0 ? void 0 : (_post$categories = post.categories) === null || _post$categories === void 0 ? void 0 : _post$categories.nodes.filter(function (item) {
    return item.parent === null;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    style: {
      letterSpacing: "-19px"
    },
    className: "post-card m-w-full block h-full overflow-hidden rounded-3xl bg-white transition-shadow duration-150 hover:shadow-[0px_0px_20px_#7c787833]",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "post-thumb inline-block align-middle tracking-normal lg:w-4/6",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        image: post === null || post === void 0 ? void 0 : (_post$featuredImage = post.featuredImage) === null || _post$featuredImage === void 0 ? void 0 : _post$featuredImage.node,
        wrapper: {
          className: "w-full relative"
        },
        className: "aspect-[16/9] h-full w-full rounded-t-3xl object-cover"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "post-des post-thumb inline-block align-middle tracking-normal lg:w-2/6",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-1 flex-col justify-between bg-[#F1F1F1] p-6 lg:bg-white",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            as: "h3",
            className: "text-2xl font-semibold leading-9 text-bbc-brand-800 line-clamp-2 lg:text-xl lg:leading-[30px]",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: post === null || post === void 0 ? void 0 : post.uri,
              children: post === null || post === void 0 ? void 0 : post.title
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mt-6 hidden text-lg text-bbc-brand-900 lg:line-clamp-3",
            dangerouslySetInnerHTML: {
              __html: post === null || post === void 0 ? void 0 : post.excerpt
            }
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex flex-wrap justify-between",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "mt-4 inline-flex items-center rounded-md bg-bbc-brand-800 px-2 py-0.5 lg:mt-6",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/icons/".concat(category[0].name.toLowerCase(), ".svg"),
              alt: "icon",
              width: 16,
              height: 16
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "inline-block text-sm font-medium text-white",
              style: {
                paddingLeft: "5px"
              },
              children: category.length > 0 && category[0].name
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "mt-4 inline-flex items-center lg:mt-6",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FiCalendar/* FiCalendar */.v, {
              size: 18
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "inline-block pl-2 text-sm",
              children: (0,functions/* formatDate */.p)(post === null || post === void 0 ? void 0 : post.date)
            })]
          })]
        })]
      })
    })]
  });
};

/* harmony default export */ var Author_CardPostItemFull = (CardPostItemFull);
CardPostItemFull.defaultProps = {
  post: {},
  layout: "vertical"
};
/** ========== */
;// CONCATENATED MODULE: ./components/templates/common/Author/PostItem/index.js




/** ========== */





var PostItem = function PostItem(_ref) {
  var _post$categories;

  var post = _ref.post,
      layout = _ref.layout;
  var category = post === null || post === void 0 ? void 0 : (_post$categories = post.categories) === null || _post$categories === void 0 ? void 0 : _post$categories.nodes.filter(function (item) {
    return item.parent === null;
  });

  if (layout === "vertical") {
    var _post$featuredImage;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex h-full flex-1 flex-col rounded-3xl bg-white transition-shadow duration-150 hover:shadow-[0px_0px_20px_#7c787833] xl:max-w-sm",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        image: post === null || post === void 0 ? void 0 : (_post$featuredImage = post.featuredImage) === null || _post$featuredImage === void 0 ? void 0 : _post$featuredImage.node,
        wrapper: {
          className: "w-full relative"
        },
        className: "aspect-[16/9] h-full w-full rounded-t-3xl object-cover"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-1 flex-col justify-between p-6",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            as: "h3",
            className: "text-lg font-semibold text-bbc-brand-800 line-clamp-2",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: post === null || post === void 0 ? void 0 : post.uri,
              children: post === null || post === void 0 ? void 0 : post.title
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mt-4 line-clamp-3",
            dangerouslySetInnerHTML: {
              __html: post === null || post === void 0 ? void 0 : post.excerpt
            }
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex flex-wrap justify-between",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "mt-6 inline-flex items-center rounded-md bg-bbc-brand-800 px-2 py-0.5",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/icons/".concat(category[0].name.toLowerCase(), ".svg"),
              alt: "icon",
              width: 16,
              height: 16
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "inline-block pl-[5px] text-sm font-medium text-white",
              children: category.length > 0 && category[0].name
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "mt-6 inline-flex items-center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FiCalendar/* FiCalendar */.v, {
              size: 18
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "inline-block pl-2 text-sm",
              children: (0,functions/* formatDate */.p)(post === null || post === void 0 ? void 0 : post.date)
            })]
          })]
        })]
      })]
    });
  }

  if (layout === "horizontal") {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "text-bbc-brand-700",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          as: "h3",
          className: "text-lg font-medium line-clamp-2",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: post === null || post === void 0 ? void 0 : post.uri,
            children: post === null || post === void 0 ? void 0 : post.title
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mt-6 inline-flex items-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FiCalendar/* FiCalendar */.v, {
            size: 18
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "inline-block pl-2 text-sm",
            children: (0,functions/* formatDate */.p)(post === null || post === void 0 ? void 0 : post.date)
          })]
        })]
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};

/* harmony default export */ var Author_PostItem = (PostItem);
PostItem.defaultProps = {
  post: {},
  layout: "vertical"
};
/** ========== */
;// CONCATENATED MODULE: ./components/templates/common/Author/index.js









var Component = function Component(_ref) {
  var data = _ref.data,
      posts = _ref.posts,
      total = _ref.total;

  var _useState = (0,react.useState)(9),
      perPage = _useState[0],
      setPerPage = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var firstPost = posts[0] || null;
  var listPost = posts.length > 1 ? posts.filter(function (item, index) {
    return index > 0;
  }) : [];

  var handleLoadMore = function handleLoadMore() {
    setIsLoading(!isLoading);
    setTimeout(function () {
      var currentPerPage = perPage + 6;
      setPerPage(currentPerPage);
      setIsLoading(false);
    }, 500);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardImageDes, {
        Card: data.Card,
        total: total
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "row mt-10",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "post-horizontal",
              children: firstPost ? /*#__PURE__*/(0,jsx_runtime.jsx)(Author_CardPostItemFull, {
                post: firstPost
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
            })
          })
        }), listPost.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "row mt-10 gap-y-10 lg:mt-20 lg:gap-y-20",
            children: listPost.map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "col-12 lg:col-4 ".concat(index < perPage ? "" : "hidden"),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Author_PostItem, {
                  post: item
                })
              }, index);
            })
          }), perPage < listPost.length ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mt-10 text-center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
              othersClass: "".concat(isLoading ? "cursor-not-allowed" : ""),
              onClick: handleLoadMore,
              disabled: isLoading,
              children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                  className: "text-primary mr-2 h-5 w-5 animate-spin group-hover:text-white",
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
                    className: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    strokeWidth: 4
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                    className: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  })]
                }), "Loading..."]
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: "Load more"
              })
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})]
      })
    })]
  });
};

/* harmony default export */ var Author = (Component);
Component.defaultProps = {
  data: {},
  posts: []
};
;// CONCATENATED MODULE: ./pages/author/bbcincorp-content-team/data.json
var data_namespaceObject = JSON.parse('{"seo":{"title":"BBCIncorp Content Team","description":"We are on the mission of providing you the most essential content, information, and tips about incorporating offshore companies.","opengraphUrl":"https://bbcincorp.com/author/bbcincorp-content-team","fullHead":"<title>BBCIncorp Content Team</title>\\n<meta name=\\"description\\" content=\\"We are on the mission of providing you the most essential content, information, and tips about incorporating offshore companies.\\" />\\n<link rel=\\"canonical\\" href=\\"https://bbcincorp.com/author/bbcincorp-content-team\\" />\\n<meta property=\\"og:locale\\" content=\\"en_US\\" />\\n<meta property=\\"og:type\\" content=\\"article\\" />\\n<meta property=\\"og:title\\" content=\\"BBCIncorp Content Team\\" />\\n<meta property=\\"og:description\\" content=\\"We are on the mission of providing you the most essential content, information, and tips about incorporating offshore companies.\\" />\\n<meta property=\\"og:url\\" content=\\"https://bbcincorp.com/author/bbcincorp-content-team\\" />\\n<meta property=\\"og:site_name\\" content=\\"BBCIncorp - Hong Kong\\" />\\n<meta property=\\"article:modified_time\\" content=\\"2022-07-06T07:31:49+00:00\\" />\\n<meta name=\\"twitter:card\\" content=\\"summary_large_image\\" />\\n<script type=\\"application/ld+json\\" class=\\"yoast-schema-graph\\">{\\"@context\\":\\"https://schema.org\\",\\"@graph\\":[{\\"@type\\":\\"Organization\\",\\"@id\\":\\"https://bbcincorp.com/author/#organization\\",\\"name\\":\\"BBCIncorp\\",\\"url\\":\\"https://bbcincorp.com/author/\\",\\"sameAs\\":[],\\"logo\\":{\\"@type\\":\\"ImageObject\\",\\"@id\\":\\"https://bbcincorp.com/author/#logo\\",\\"inLanguage\\":\\"en-US\\",\\"url\\":\\"https://bbcincorp.com/wp-content/uploads/sites/2/2022/07/logo-bbcincorp.png\\",\\"contentUrl\\":\\"https://bbcincorp.com/wp-content/uploads/sites/2/2022/07/logo-bbcincorp.png\\",\\"width\\":154,\\"height\\":154,\\"caption\\":\\"BBCIncorp\\"},\\"image\\":{\\"@id\\":\\"https://bbcincorp.com/author/#logo\\"}},{\\"@type\\":\\"WebSite\\",\\"@id\\":\\"https://bbcincorp.com/author/#website\\",\\"url\\":\\"https://bbcincorp.com/author/\\",\\"name\\":\\"BBCIncorp - Hong Kong\\",\\"description\\":\\"\\",\\"publisher\\":{\\"@id\\":\\"https://bbcincorp.com/author/#organization\\"},\\"potentialAction\\":[{\\"@type\\":\\"SearchAction\\",\\"target\\":\\"https://bbcincorp.com/author/?s={search_term_string}\\",\\"query-input\\":\\"required name=search_term_string\\"}],\\"inLanguage\\":\\"en-US\\"},{\\"@type\\":\\"WebPage\\",\\"@id\\":\\"https://bbcincorp.com/author/bbcincorp-content-team#webpage\\",\\"url\\":\\"https://bbcincorp.com/author/bbcincorp-content-team\\",\\"name\\":\\"BBCIncorp Content Team\\",\\"isPartOf\\":{\\"@id\\":\\"https://bbcincorp.com/author/#website\\"},\\"datePublished\\":\\"2022-06-01T02:45:08+00:00\\",\\"dateModified\\":\\"2022-07-06T07:31:49+00:00\\",\\"description\\":\\"We are on the mission of providing you the most essential content, information, and tips about incorporating offshore companies.\\",\\"breadcrumb\\":{\\"@id\\":\\"https://bbcincorp.com/author/bbcincorp-content-team#breadcrumb\\"},\\"inLanguage\\":\\"en-US\\",\\"potentialAction\\":[{\\"@type\\":\\"ReadAction\\",\\"target\\":[\\"https://bbcincorp.com/author/bbcincorp-content-team\\"]}]},{\\"@type\\":\\"BreadcrumbList\\",\\"@id\\":\\"https://bbcincorp.com/author/bbcincorp-content-team#breadcrumb\\",\\"itemListElement\\":[{\\"@type\\":\\"ListItem\\",\\"position\\":1,\\"item\\":{\\"@type\\":\\"WebPage\\",\\"@id\\":\\"https://bbcincorp.com/author/\\",\\"url\\":\\"https://bbcincorp.com/author/\\",\\"name\\":\\"Home\\"}},{\\"@type\\":\\"ListItem\\",\\"position\\":2,\\"item\\":{\\"@type\\":\\"WebPage\\",\\"@id\\":\\"https://bbcincorp.com/author/bbcincorp-content-team\\",\\"url\\":\\"https://bbcincorp.com/author/bbcincorp-content-team\\",\\"name\\":\\"Bbcincorp content team\\"}}]}]}</script>"},"Card":{"title":"BBCIncorp Content Team","thedescription":["The BBCIncorp content team is passionate about helping businesses expand and grow globally by producing quality content for references, and assisting your company to make informed decisions. Our blog covers diverse topics, from company formation to business banking, etc. in order to provide best practices and practical methods that set businesses up to continuously innovate and improve.","Find out how our team produces qualified content for BBCIncorp with the following steps:","<ul class=\'list-disc pl-8\'><li>The content production starts with researching concerning subjects imperative to business development. Then, it comes to building outlines and drafting.</li><li>Once the draft is complete, it will be checked by our legal team to ensure accuracy. We try our best to provide the information backup with relevant law.</li><li>Finally, the content is published on our website. After publication, our team will continue to administrate the content so that it remains relevant and up-to-date.</li></ul>","This process ensures that all our content is insightful and accurate so businesses can rely on us for reliable and informative references.","We are proud that our insights are based on expert knowledge and service expertise. And it is the best achievement to be able to help businesses fulfill their goal, such as making revenue-impacting decisions."],"image":{"src":"/assets/images/common/author/icon-bbcincorp-content-team.svg"},"socialNetwork":[{"icon":"FaTwitter","url":"https://twitter.com/bbcincorp/","color":"#1DA1F2"},{"icon":"FaFacebookF","url":"https://www.facebook.com/bbcincorp","color":"#1877F2"},{"icon":"FaLinkedinIn","url":"https://www.linkedin.com/company/bbcincorp","color":"#0077B5"}]}}');
;// CONCATENATED MODULE: ./pages/author/bbcincorp-content-team/index.js








var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data,
      seo = _ref.seo;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(head["default"], {
      children: [ false ? /*#__PURE__*/0 : /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "robots",
        content: "noindex, nofollow"
      }), (seo === null || seo === void 0 ? void 0 : seo.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:title",
        content: "".concat(seo === null || seo === void 0 ? void 0 : seo.title)
      }), (seo === null || seo === void 0 ? void 0 : seo.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:description",
        content: seo === null || seo === void 0 ? void 0 : seo.description
      }), (seo === null || seo === void 0 ? void 0 : seo.opengraphUrl) && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:url",
        content: seo === null || seo === void 0 ? void 0 : seo.opengraphUrl
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      locationRouter: "hk",
      isStaticSeo: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Author, {
        data: data_namespaceObject,
        posts: data === null || data === void 0 ? void 0 : data.posts,
        total: data === null || data === void 0 ? void 0 : data.total
      })
    })]
  });
}

/***/ }),

/***/ 43001:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/author/bbcincorp-content-team",
      function () {
        return __webpack_require__(67611);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39108:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"Index_cardContainer__gYNx2","cardWrapper":"Index_cardWrapper__6xv3w","imgCard":"Index_imgCard__Y94JE"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3105,7915,4525,4090,9738,9774,2888,179], function() { return __webpack_exec__(43001); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);